import { PortableText } from '@portabletext/react'
import Image from 'next/image'
import { ReactNode } from 'react'

import { FadeUpInView } from '~/components/FadeUpInView'
import { Column, Grid } from '~/components/Grid'
import { urlForImage } from '~/lib/sanity.image'
import { SecondaryPage } from '~/lib/sanity.queries'

import PortableTextScrollAnimation, {
  TextScrollAnimation,
} from '../TextAnimation'

export default function HowItWorks({
  content,
  howItWorksArtwork,
}: {
  content: SecondaryPage['howItWorks']
  howItWorksArtwork?: ReactNode[]
}) {
  return (
    <section className="my-60">
      <Grid className="text-center mb-20">
        <Column className="col-span-12 relative">
          <div className="bg-gradient-blur opacity-20"></div>
          <div className="flex flex-col items-center justify-center relative">
            {content?.title && (
              <div className="h3 2xl:h4 text-center text-pretty 2xl:pb-4 mb-4 2xl:mb-8">
                <PortableTextScrollAnimation value={content.title} />
              </div>
            )}
            {content?.body && (
              <div className="body-large text-grey text-pretty max-w-3xl mx-auto">
                <PortableTextScrollAnimation value={content.body} />
              </div>
            )}
          </div>
        </Column>
      </Grid>
      {content.items.map((item, index) => (
        <Grid
          key={index}
          className={`mb-40 2xl:mb-0 2xl:h-[50vh] ${index === 0 ? '2xl:-mt-[10vh]' : ''} `}
        >
          <Column
            className={`col-span-12 2xl:col-span-6 flex items-center justify-center order-1 ${index % 2 === 0 ? '2xl:order-1' : '2xl:order-2 2xl:col-start-6'}`}
          >
            <div className={`flex flex-col justify-center text-left`}>
              {item.title && (
                <div className="body-large text-pretty text-center 2xl:text-left">
                  <TextScrollAnimation text={item.title} />
                </div>
              )}
              <div className="mt-8 body-large text-grey max-w-md text-pretty text-center 2xl:text-left">
                <TextScrollAnimation text={item.body} />
              </div>
            </div>
          </Column>
          <Column
            className={`col-span-12 order-2 ${index % 2 === 0 ? '2xl:col-span-3 2xl:col-start-8 2xl:order-2' : '2xl:order-1 2xl:col-span-3 2xl:col-start-3'}`}
          >
            <div className="w-full h-full flex flex-col items-center justify-center">
              <FadeUpInView className="w-full">
                <div className="w-full relative mt-10 2xl:mt-0">
                  {howItWorksArtwork && howItWorksArtwork[index]}
                </div>
              </FadeUpInView>
            </div>
          </Column>
        </Grid>
      ))}
    </section>
  )
}
